import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

import type Status from 'modules/integrations_primobox/lib/interfaces/Status'
import { colorFromStatus, translateStatus } from 'modules/integrations_primobox/lib/statusHelpers'

interface Props {
  status: Status
}

const StatusTag = ({ status }: Props) => {
  return (
    <Box width="full" flexDirection="row" gap="s16" paddingTop="s16">
      <Tag leftItem="circle" showCircle type={colorFromStatus(status.status)}>
        {translateStatus(status.status)}
      </Tag>
      <Text.Normal size="200">{dateBackendDateTimeToUI(status.updatedAt)}</Text.Normal>
    </Box>
  )
}

export default StatusTag
